import { Component, OnInit, ViewChild } from '@angular/core';
import { async } from '@angular/core/testing';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { User } from 'src/app/beans/login/user/user.bean';
import { Site } from 'src/app/beans/site/site.bean';
import { SlotModel } from 'src/app/beans/slot-model/slot-model.bean';
import { SlotModelDay } from 'src/app/beans/slot-model/slot-model.day.bean';
import { SlotModelTime } from 'src/app/beans/slot-model/slot-model.time.bean';
import { SlotVisibility } from 'src/app/beans/slot/slot.visibility.bean';
import { CustomSelect } from 'src/app/components/select/custom/custom-select/custom.select';
import { DaySelect } from 'src/app/components/select/day/day.select';
import { OrganizationSelect } from 'src/app/components/select/organization/organization-select/organization.select';
import { SiteSelect } from 'src/app/components/select/site/site-select/site.select';
import { addIdsToArray, CustomColumn, CustomIconButton, CustomTableComponent, HeaderButton } from 'src/app/components/table/custom-table/custom-table.component';
import { ModelSlotDialog } from 'src/app/dialogs/model-slot/model.slot.dialog';
import { ModelCopyDialog } from 'src/app/dialogs/slot-model-copy/slot.model.copy.dialog';
import { SlotModelDialog } from 'src/app/dialogs/slot-model/slot.model.dialog';
import { DialogsReturnCode } from 'src/app/enums/dialogs/returnCode.enum';
import { RoutingPages } from 'src/app/enums/routing/routing-pages.enum';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { PipeManager } from 'src/app/managers/pipe/pipe.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';

@Component({
  selector: 'slot.model',
  templateUrl: './slot.model.page.html',
  styleUrls: ['./slot.model.page.scss']
})
export class SlotModelPage implements OnInit {

  public  models    : SlotModel[]
  public modelDay : SlotModelDay
  oldDay : number
  values   : any[] = []

  visibilities : SlotVisibility[]

  orgSelect: OrganizationSelect
  @ViewChild('orgManager') set _orgSelect(orgSelect: OrganizationSelect){
    if (orgSelect){
      this.orgSelect = orgSelect
    }
  }
  site: Site
  @ViewChild('siteManager') set _siteSelect(siteSelect: SiteSelect){
    if (siteSelect){
      this.site = siteSelect.getSelectedValue()
    }
  }

  model: SlotModel
  @ViewChild('modelManager') set _modelSelect(modelSelect: CustomSelect){
    if(modelSelect){
      this.model = modelSelect.getSelectedValue();
    }
  }

  day: number
  @ViewChild('dayManager') set _daySelect(daySelect: DaySelect){
    if(daySelect){
      this.day = daySelect.getSelectedValue().id;
      this.oldDay = this.day
    }
  }

  @ViewChild('slotModelTable') slotModelTable: CustomTableComponent

  slotmodelColumns: CustomColumn [] = [
    {
      isId   : true,
      label  : "id",
      name   : "id",
      display: ( val : any ) => false ,
    },
    {
      label: "time",
      name : "tables.slotmodel.time"
    },
    {
      label: "type",
      name : "tables.slotmodel.type",
      pipe : (type: any) => this._pipe.tables().get_visibility(type, this.visibilities)
    },
    {
      label: "count",
      name : "tables.slotmodel.count"
    },
  ]

  icon_buttons: CustomIconButton[] = [
    {
      label  : "manage",
      column : "tables.slotmodel.manage",
      icon   : "collections_bookmark",
      tooltip: "tables.slotmodel.manage",
      action : (el: any, pos: number) => {
        this.modify(el)
      }

    },
    {
      label  : "delete",
      column : "tables.slotmodel.delete",
      icon   : "delete",
      tooltip: "tables.slotmodel.delete",
      action : (el: any, pos: number) => {
        this.delete(el)
      }
    },
  ]

  header_buttons: HeaderButton[] = [
    {
      label    : "create",
      name     : "tables.slotmodel.header_button.create",
      action   :  (el: any) => {
        this.create()
      } ,
      display  : () => true
    },
    {
      label    : "copy",
      name     : "tables.slotmodel.header_button.copy",
      action   :  (el: any) => {
        this.copy()
      } ,
      display  : () => this.modelDay?.times.length > 0
    }

  ]

  constructor(
    private _handler : HandlerManager,
    private _loader  : LoadingManager,
    private _session : SessionManager,
    private _dialog : MatDialog     ,
    private _pipe   : PipeManager   ,
    private _router : Router
  ) { }

  ngOnInit(): void {
  }

  async init()
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    this._loader.start()

    let response = null

    response = await this._handler.slotModel().list((user as User).token, this.site.id)

    this._loader.stop()

    this.models = response.list as SlotModel[]

    this.getVisibilities()

  }

  //----------------------------------------------------------------------------------------------------

  siteChange(site:Site)
  {
    this.site = site;
    this.models = null
    this.init()
  }

  modelChange(model:SlotModel)
  {
    this.model = null
    this.model = model;
    this.loadDetails()
  }

  dayChange(day: any)
  {
    this.day = day.id

    this.slotModelTable.reloadData()

    this.modelDay = this.model.modelDetails?.days[this.day]
    this.values = this.modelDay?.times

    this.values?.sort((a,b) => this._pipe.sorting().sort(a.time,b.time))

    this.values = addIdsToArray(this.values)

    this.slotModelTable.dataLoaded()
  }

  async loadDetails()
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    this._loader.start()
    this.slotModelTable.reloadData()

    let response = null

    response = await this._handler.slotModel().detail((user as User).token, this.model.id)

    this._loader.stop()
    this.slotModelTable.dataLoaded()

    this.model.modelDetails = response.list[0].modelDetails

    this.modelDay = this.model.modelDetails?.days[this.day];

    this.values = this.modelDay.times as SlotModelTime[]

    this.values?.sort((a,b) => this.sortTime(a,b))

    this.values = addIdsToArray(this.values)
  }

  sortTime(a,b){
      if(a.time > b.time){
        return 1
      }
      if(a.time < b.time){
        return -1
      }
      return 0
  }


  //----------------------------------------------------------------------------------------------------

  createModel()
  {
    const dialogConfig = new MatDialogConfig();


    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;

    let dialog: any

    dialogConfig.data = {
      id : null,
      orgId   : this.orgSelect.getSelectedValue().id,
      enabled : 1
    }

    dialog = this._dialog.open(SlotModelDialog, dialogConfig);

    dialog.afterClosed().subscribe(async (data: any) =>
    {

      //Refresh models
      if (data.code == DialogsReturnCode.SLOTMODEL_MODEL)
      {
        this.models = null
        this.init()
      }
    })
  }

  modifyModel()
  {
    const dialogConfig = new MatDialogConfig();


    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;

    let dialog: any

    dialogConfig.data = {
      id      : this.model.id,
      orgId   : this.orgSelect.getSelectedValue().id,
      name    : this.model.name,
      type    : this.model.siteId ? 10 : 20,
      typeId  : this.model.siteId ? this.model.siteId : this.model.organizationId,
      note    : this.model.note,
      enabled : this.model.enabled
    }

    dialog = this._dialog.open(SlotModelDialog, dialogConfig);

    dialog.afterClosed().subscribe(async (data: any) =>
    {

      //Refresh models
      if (data.code == DialogsReturnCode.SLOTMODEL_MODEL)
      {
        this.models = null
        this.init()
      }
    })
  }

  //----------------------------------------------------------------------------------------------------



  async create()
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;

    let dialog: any

    dialogConfig.data = {
      visibilities : this.visibilities
    }

    dialog = this._dialog.open(ModelSlotDialog, dialogConfig);


    dialog.afterClosed().subscribe(async (data: any) =>
    {

      if(data.code != DialogsReturnCode.SLOTMODEL_SLOT) return

      this.values.push(data.slot)
      this.values = this.values.sort((n1, n2) => {
        if(n1.time>n2.time)
          return 1
        if(n1.time<n2.time)
          return -1
        return 0
      })

      this._loader.start()

      let response = null

      response = await this._handler.slotModel().manageSlot((user as User).token, this. model.id, this.modelDay)

      this._loader.stop()

      this.loadDetails()

    })

  }

  async modify(el: any)
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;

    let dialog: any

    dialogConfig.data = {
      slot : el,
      visibilities : this.visibilities
    }

    dialog = this._dialog.open(ModelSlotDialog, dialogConfig);

    dialog.afterClosed().subscribe(async (data: any) =>
    {
      if(data.code != DialogsReturnCode.SLOTMODEL_SLOT) return

      this.values[this.values.indexOf(el)] = data.slot

      this._loader.start()

      let response = null

      response = await this._handler.slotModel().manageSlot((user as User).token, this. model.id, this.modelDay)

      this._loader.stop()

      this.loadDetails()

    })

  }

  async copy()
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;

    let dialog: any

    dialogConfig.data = {
      curDay : this.day
    }

    dialog = this._dialog.open(ModelCopyDialog, dialogConfig);

    dialog.afterClosed().subscribe(async (data: any) =>
    {
      if(data.code != DialogsReturnCode.SLOTMODEL_SLOT) return

      console.log(data.days);

      this._loader.start()

      for (let index = 0; index < data.days.length; index++) {
        let copyModelDay = {...this.modelDay}
        copyModelDay.day = data.days[index]

        let response = null

        response = await this._handler.slotModel().manageSlot((user as User).token, this. model.id, copyModelDay)

      }

      this._loader.stop()

      this.loadDetails()

    })
  }

  async delete(el: any)
  {
    this.values.splice(this.values.indexOf(el), 1);

    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    this._loader.start()

    let response = await this._handler.slotModel().manageSlot((user as User).token, this. model.id, this.modelDay)

    this._loader.stop()

    this.loadDetails()
  }

  //-------------------------------------------------------------------------

  goBack()
  {
    const route = "/" + RoutingPages.SLOTAUTOMATE;
    this._router.navigate([route]);
  }

  async getVisibilities()
  {
    this._loader.start()

    let response = null
    response = await this._handler.slot().visibility()

    this._loader.stop()

    if(!response     ) return
    if(!response.list) return

    this.visibilities = response.list as SlotVisibility[];
  }


}
